import React, { Component } from "react";
import { Card, Container } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import RestServiceStatic from "../services/rest.service"

export default class NotificationBox extends Component {

  constructor(props) {

    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
        checked: true
    }
  } 

  handleChange() {
    
    RestServiceStatic.setNotifications(!this.state.checked).then(response => {

      this.setState({
        checked: !this.state.checked
      });

    }).catch(e => {

      this.setState({
        checked: this.state.checked
      });

    });
  }

  render() {
    return (
      <Container>
        <Card className="border-primary">
          <Card.Body className="text-center text-primary">
            {this.props.msg}
            <Form.Check className="d-flex justify-content-center mt-4"
              type="switch"
              id="notification-switch"
              checked={this.state.checked}
              label="&nbsp;Notify me"
              onChange={this.handleChange}
              />
          </Card.Body>       
        </Card>
      </Container>
    );
  }
}
